export const userHasPermission = (user, permission) => {
    const isVerbalOnlyPerm = /^Verbal/.test(permission) || /^Story/.test(permission);
    return !!user?.Role?.RolePermissions?.find((rolePermission) => ((isVerbalOnlyPerm && user?.isVerbal) || !isVerbalOnlyPerm) &&
        (rolePermission.permission === permission || rolePermission.permission === "FullAccess"));
};
